module.exports = __webpack_public_path__ + "img/9788971996768.994af384.jpg";